var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.293 2.79395H3.29297C2.74069 2.79395 2.29297 3.24167 2.29297 3.79395V15.7939C2.29297 16.3462 2.74069 16.7939 3.29297 16.7939H19.293C19.8453 16.7939 20.293 16.3462 20.293 15.7939V3.79395C20.293 3.24167 19.8453 2.79395 19.293 2.79395ZM3.29297 0.793945C1.63612 0.793945 0.292969 2.1371 0.292969 3.79395V15.7939C0.292969 17.4508 1.63612 18.7939 3.29297 18.7939H19.293C20.9499 18.7939 22.293 17.4508 22.293 15.7939V3.79395C22.293 2.1371 20.9499 0.793945 19.293 0.793945H3.29297Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52465 5.15354C4.87822 4.72926 5.50878 4.67194 5.93306 5.0255L10.6527 8.95852C11.0236 9.26752 11.5622 9.26752 11.9331 8.95852L16.6527 5.0255C17.077 4.67194 17.7076 4.72926 18.0611 5.15354C18.4147 5.57782 18.3574 6.20838 17.9331 6.56195L13.2134 10.4949C12.1009 11.4221 10.4849 11.4221 9.37228 10.4949L4.65269 6.56195C4.22841 6.20838 4.17109 5.57782 4.52465 5.15354Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebMailIcon);
export default __webpack_public_path__ + "static/media/web_Mail_icon.f81cea6ad575ddde8f2a536c09d60aa9.svg";
export { ForwardRef as ReactComponent };